<div class="breadCrumbRow" [ngClass]="{'hidden' : hideBreadCrumb}">
    <div class="crumbs">
      <!-- HOME -->
      <div>
        <a routerLink="/" class="breadcrumb" title="Go back to Home" aria-label="Home">
            <mat-icon aria-hidden="false" aria-label="Home Icon">home</mat-icon>
        </a>
      </div>
      <!-- My / Team Notebooks -->
      <div *ngIf="showNotebookLevel">
        <ng-container *ngIf="showMyNotebookLevel">
          <mat-icon class="crumb-sep" aria-hidden="true">chevron_right</mat-icon>
          <a routerLink="/notebooks/my-notebooks" class="breadcrumb" title="Go back to My Notebooks" aria-label="My Notebooks">
            <mat-icon aria-hidden="false" aria-label="My Notebooks Icon">person</mat-icon>
          </a>
        </ng-container>
        <ng-container *ngIf="showTeamNotebookLevel">
          <mat-icon class="crumb-sep" aria-hidden="true">chevron_right</mat-icon>
          <a routerLink="/notebooks/team-notebooks" class="breadcrumb" title="Go back to Team Notebooks" aria-label="Team Notebooks">
            <mat-icon aria-hidden="false" aria-label="Team Notebooks Icon">groups</mat-icon>
          </a>
        </ng-container>
      </div>
      <!-- CMS Levels -->
      <div *ngIf="showLevel1">
        <mat-icon class="crumb-sep" aria-hidden="true">chevron_right</mat-icon>
        <a routerLink="/cms" class="breadcrumb">{{customProjectName}}s</a>
       </div>
      <div *ngIf="showLevel1">
       <mat-icon class="crumb-sep" aria-hidden="true">chevron_right</mat-icon>
       <a routerLink="/cms" class="breadcrumb"><span
          [ngClass]="{hideOnMobile: cssHideOnMobilelv1}">{{level1Name}}</span></a>
      </div>
      <div *ngIf="showLevel2">
       <mat-icon class="crumb-sep" aria-hidden="true">chevron_right</mat-icon>
       <a routerLink="/cms/1/{{level2ProjectID}}" class="breadcrumb"><span
        [ngClass]="{hideOnMobile: cssHideOnMobilelv2}">{{level2Name}}</span></a>
      </div>
      <div *ngIf="showLevel3">
        <mat-icon class="crumb-sep" aria-hidden="true">chevron_right</mat-icon>
        <a routerLink="/cms/2/{{level2ProjectID}}/{{level3ProjectID}}" class="breadcrumb"><span
          [ngClass]="{hideOnMobile: cssHideOnMobilelv3}">{{level3Name}}</span></a>
      </div>
      <div *ngIf="showLevel4">
        <mat-icon class="crumb-sep" aria-hidden="true">chevron_right</mat-icon>
        <a routerLink="/cms/3/{{level2ProjectID}}/{{level3ProjectID}}/{{level4ProjectID}}" class="breadcrumb"><span
          [ngClass]="{hideOnMobile: cssHideOnMobilelv4}">{{level4Name}}</span></a>
      </div>
      <div *ngIf="showLevel5">
        <mat-icon class="crumb-sep" aria-hidden="true">chevron_right</mat-icon>
        <a routerLink="/cms/4/{{level2ProjectID}}/{{level3ProjectID}}/{{level4ProjectID}}/{{level5ProjectID}}" class="breadcrumb"><span
          [ngClass]="{hideOnMobile: cssHideOnMobilelv5}">{{level5Name}}</span></a>
      </div>
      <div *ngIf="showLevel6">
        <mat-icon class="crumb-sep" aria-hidden="true">chevron_right</mat-icon>
        <a routerLink="/cms/5/{{level2ProjectID}}/{{level3ProjectID}}/{{level4ProjectID}}/{{level5ProjectID}}/{{level6ProjectID}}"
          class="breadcrumb">{{level6Name}}</a>
      </div>
      <div *ngIf="showSectionPage">
        <mat-icon class="crumb-sep" aria-hidden="true">chevron_right</mat-icon>
        <span class="breadcrumb is-current">{{sectionName}}</span>
       </div>
       <div *ngIf="showNotebook">
        <mat-icon class="crumb-sep" aria-hidden="true">chevron_right</mat-icon>
        <span class="breadcrumb is-current">{{notebookName}}</span>
      </div>
    </div>
</div>
